import AxiosInstance from "../config/AxiosInstance";

export const createClient = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/clients', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};


export const getClients = async (page: any, limit: any, searchValue: any, companyId: any, clientType: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/clients', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
                clientType: clientType
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getActiveInvoice = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/clients/getActiveInvoiceForClient', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getArchiveInvoice = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/clients/getArchiveInvoiceForClient', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getClientStatement = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/client-statement', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getClientStatementPdf = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/client-statement/pdf', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const logout = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/logout', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getDetailClients = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/clients/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const upadteDetailClients = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/clients/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}
export const deleteClient = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/clients/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}